import { useEffect, useState } from "react";
import { subMonths, format } from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  CardHeader,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  IconButton,
  Button,
  CurrencyInput,
} from "../../../../../components";
import { unformatPrice, formatPrice } from "../../../../../utils";

const TOTAL_MESES = 12;

const capitalizar = (texto) =>
  texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : texto;

const gerarMeses = () => {
  return Array.from({ length: TOTAL_MESES }, (_, indice) => {
    const data = subMonths(new Date(), indice + 1);
    return {
      chave: format(data, "yyyy-MM"),
      label: capitalizar(format(data, "MMM 'de' yyyy", { locale: ptBR })),
    };
  });
};

const FaturamentoMensalDialog = ({ open, setOpen, valor, onSalvar }) => {
  const [faturamentos, setFaturamentos] = useState({});
  const meses = gerarMeses();

  useEffect(() => {
    if (open) {
      try {
        const valores = valor ? JSON.parse(valor) : {};
        setFaturamentos(valores && typeof valores === "object" ? valores : {});
      } catch {
        setFaturamentos({});
      }
    }
  }, [open, valor]);

  const handleClose = () => setOpen(false);

  const handleBlur = (chave) => (event) => {
    const valorConvertido = unformatPrice(event.target.value);
    setFaturamentos((prevState) => ({
      ...prevState,
      [chave]: valorConvertido ? Number(valorConvertido) : 0,
    }));
  };

  const handleSalvar = () => {
    onSalvar(JSON.stringify(faturamentos));
    setOpen(false);
  };

  const totalPreenchidos = meses.filter(
    (mes) => Number(faturamentos[mes.chave]) > 0,
  ).length;

  const total = meses.reduce(
    (soma, mes) => soma + (Number(faturamentos[mes.chave]) || 0),
    0,
  );

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <CardHeader
        title="Faturamento mensal"
        subheader="Preencha o valor faturado em cada mês dos últimos 12 meses."
        action={
          <IconButton onClick={handleClose}>
            <i className="ph-bold ph-x"></i>
          </IconButton>
        }
      />
      <DialogContent dividers sx={{ maxHeight: 400 }}>
        <Grid container spacing={2}>
          {meses.map((mes) => (
            <Grid
              key={mes.chave}
              item
              container
              xs={12}
              spacing={2}
              alignItems="center"
            >
              <Grid item xs={5}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {mes.label}
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <CurrencyInput
                  id={`faturamento-${mes.chave}`}
                  name={mes.chave}
                  margin="none"
                  value={faturamentos[mes.chave]}
                  onBlur={handleBlur(mes.chave)}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <Grid container alignItems="center" className="px-3 pt-2">
        <Grid item xs={6}>
          <Typography variant="body2" color="textSecondary">
            {totalPreenchidos} de {TOTAL_MESES} meses preenchidos
          </Typography>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Total: {formatPrice(total)}
          </Typography>
        </Grid>
      </Grid>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleSalvar}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FaturamentoMensalDialog;
